const $document         = $(document),
      $window           = $(window),
      $htmlBody         = $('html, body'),
      $html             = $('html'),
      $body             = $('body'),
      $main             = $('main'),
      $footer           = $('footer');

const elementsTweenX = [
  {
    element: '.intro__grid__cell',
    options: {
      x: -80,
      ease: Power4.easeInOut
    }
  },
  {
    element: '.intro__grid__cell--img',
    options: {
      x: 40,
      ease: Power4.easeInOut
    }
  },
  {
    element: '.leisure__grid__cell--img',
    options: {
      x: -80,
      ease: Power4.easeInOut
    }
  },
  {
    element: '.leisure__grid__cell--img + .leisure__grid__cell',
    options: {
      x: 40,
      ease: Power4.easeInOut
    }
  },
  {
    element: '.leisure-sea__grid__cell--img',
    options: {
      x: -80,
      ease: Power4.easeInOut
    }
  },
  {
    element: '.leisure-sea__grid__cell',
    options: {
      x: 40,
      ease: Power4.easeInOut
    }
  },
  {
    element: '.leisure-sea__grid__cell--img',
    options: {
      x: -80,
      ease: Power4.easeInOut
    }
  },
  {
    element: '.leisure-sea__grid__cell',
    options: {
      x: 40,
      ease: Power4.easeInOut
    }
  },
  {
    element: '.leisure__grid__cell--img--right.mountain + .leisure__grid__cell',
    options: {
      x: -80,
      ease: Power4.easeInOut
    }
  },
  {
    element: '.leisure__grid__cell--img--right.mountain',
    options: {
      x: 40,
      ease: Power4.easeInOut
    }
  },
  {
    element: '.leisure-mountain__grid__cell--img',
    options: {
      x: -80,
      ease: Power4.easeInOut
    }
  },
  {
    element: '.leisure-mountain__grid__cell--img + .leisure-mountain__grid__cell',
    options: {
      x: 40,
      ease: Power4.easeInOut
    }
  },
  {
    element: '.leisure-mountain__grid__cell--img--right + .leisure-mountain__grid__cell',
    options: {
      x: -80,
      ease: Power4.easeInOut
    }
  },
  {
    element: '.leisure-mountain__grid__cell--img--right',
    options: {
      x: 40,
      ease: Power4.easeInOut
    }
  },
  {
    element: '.event__grid__cell',
    options: {
      x: -80,
      ease: Power4.easeInOut
    }
  },
  {
    element: '.event__grid__cell--img--right',
    options: {
      x: 40,
      ease: Power4.easeInOut
    }
  },
  {
    element: '.tourism__grid__cell--img',
    options: {
      x: -80,
      ease: Power4.easeInOut
    }
  },
  {
    element: '.tourism__grid__cell',
    options: {
      x: 40,
      ease: Power4.easeInOut
    }
  },
  {
    element: '.tourism-contents__grid__cell--img--right + .tourism-contents__grid__cell',
    options: {
      x: -80,
      ease: Power4.easeInOut
    }
  },
  {
    element: '.tourism-contents__grid__cell--img--right',
    options: {
      x: 40,
      ease: Power4.easeInOut
    }
  },
  {
    element: '.tourism-contents__grid__cell--img',
    options: {
      x: -80,
      ease: Power4.easeInOut
    }
  },
  {
    element: '.tourism-contents__grid__cell--img + .tourism-contents__grid__cell',
    options: {
      x: 40,
      ease: Power4.easeInOut
    }
  },
  {
    element: '.greentown__grid__cell',
    options: {
      x: -80,
      ease: Power4.easeInOut
    }
  },
  {
    element: '.greentown__grid__cell--img--right',
    options: {
      x: 40,
      ease: Power4.easeInOut
    }
  },
  {
    element: '.greentown-contents__grid__cell--img',
    options: {
      x: -80,
      ease: Power4.easeInOut
    }
  },
  {
    element: '.greentown-contents__grid__cell',
    options: {
      x: 40,
      ease: Power4.easeInOut
    }
  }
];

const elementsTweenY = [
  {
    element: '.intro__map',
    options: {
      y: 80,
      ease: Power4.easeInOut
    }
  },
  {
    element: '.leisure__header',
    options: {
      y: 80,
      ease: Power4.easeInOut
    }
  },
  {
    element: '.leisure-sea__cell',
    options: {
      y: 80,
      ease: Power4.easeInOut
    }
  },
  {
    element: '.leisure-mountain__cell',
    options: {
      y: 80,
      ease: Power4.easeInOut
    }
  },
  {
    element: '.event__header',
    options: {
      y: 80,
      ease: Power4.easeInOut
    }
  },
  {
    element: '.tourism__header',
    options: {
      y: 80,
      ease: Power4.easeInOut
    }
  },
  {
    element: '.greentown__header',
    options: {
      y: 80,
      ease: Power4.easeInOut
    }
  },
  {
    element: '.greentown-contents__cell',
    options: {
      y: 80,
      ease: Power4.easeInOut
    }
  }
];

export {$document,$window,$htmlBody,$html,$body,$main,$footer,elementsTweenX,elementsTweenY}